import React from 'react';
import "../../styles/home/category-grid.css";
import { Link } from 'react-router-dom';

const CategoryGrid = () => {
    return (
        <section className="circle-main">
            <div className="container circle-inner">
                <Link to={"/admission"}>
                    <img
                        src="../assets/images/circle-category/admission.png"
                        alt="Admissions"
                    />
                    <h6>Admissions</h6>
                </Link>
                <Link to={"/exam-related-info"}>
                    <img src="../assets/images/circle-category/exam.png" alt="Examination" />
                    <h6>Examination</h6>
                </Link>
                <Link to={"https://result.ccsuniversity.ac.in/"} target="_blank">
                    <img src="../assets/images/circle-category/Result.png" alt="Result" />
                    <h6>Result</h6>
                </Link>
                <Link to={"/omr"}>
                    <img
                        src="../assets/images/circle-category/omr icon.png"
                        alt="OMR Result"
                    />
                    <h6>OMR Answer Keys</h6>
                </Link>
                <Link to={"https://www.ccsuniversitycdoe.com/"}>
                    <img src="../assets/images/circle-category/odl 2.png" alt="odl" />
                    <h6>ODL</h6>
                </Link>
                <Link to={"/affiliation"}>
                    <img
                        src="../assets/images/circle-category/affiliation.png"
                        alt="Affiliation"
                    />
                    <h6>Affiliation</h6>
                </Link>
                <Link to={"/syllabus"}>
                    <img
                        src="../assets/images/circle-category/syllabus.png"
                        alt="syllabus"
                    />
                    <h6>Syllabus</h6>
                </Link>
                <Link to={"http://ccsuniversityhostel.com/"} target="_blank">
                    <img src="../assets/images/circle-category/HOSTEL.png" alt="HOSTEL" />
                    <h6>Hostel</h6>
                </Link>
                <Link to={"/admission-brochure"}>
                    <img
                        src="../assets/images/circle-category/brochure.png"
                        alt="brochure"
                    />
                    <h6>Brochure</h6>
                </Link>
                <Link to={"/admission"}>
                    <img
                        src="../assets/images/circle-category/registration.png"
                        alt="registration"
                    />
                    <h6>Registration</h6>
                </Link>
                <Link to={"/prog-offered"}>
                    <img
                        src="../assets/images/circle-category/programs offered.png"
                        alt="programs offered"
                    />
                    <h6>Programs Offered</h6>
                </Link>
                <Link to={"https://scriet.ccsuniversity.ac.in"} target="_blank">
                    <img
                        src="../assets/images/circle-category/university.png"
                        alt="university"
                    />
                    <h6>University Engineering College</h6>
                </Link>
                <Link to={"https://www.llrmmedicalcollege.edu.in/"} target="_blank">
                    <img
                        src="../assets/images/circle-category/University Medical College.png"
                        alt="University Medical College"
                    />
                    <h6>University Medical College</h6>
                </Link>
                <Link to={"https://forms.ccsuforms.in/FeePayPanel/"} target="_blank">
                    <img
                        src="../assets/images/circle-category/online pay.png"
                        alt="online fees payment"
                    />
                    <h6>Online Fees Payment</h6>
                </Link>
                <Link
                    to={"https://alumni.ccsuniversity.ac.in/"}
                    target="_blank"
                >
                    <img
                        src="../assets/images/circle-category/notable alumni.png"
                        alt="notable alumni"
                    />
                    <h6>Alumni</h6>
                </Link>
                <Link to={"/career"}>
                    <img
                        src="../assets/images/circle-category/recruitment.png"
                        alt="Recruitments"
                    />
                    <h6>Recruitments</h6>
                </Link>
                <Link to={"/iqac"}>
                    <img src="../assets/images/circle-category/iqac.png" alt="IQAC" />
                    <h6>IQAC</h6>
                </Link>
                <Link to={"https://education-policy.ccsuniversity.ac.in/"} target="_blank">
                    <img src="../assets/images/circle-category/nep.png" alt="NEP" />
                    <h6>NEP</h6>
                </Link>
                <Link to={"/research"}>
                    <img
                        src="../assets/images/circle-category/research.png"
                        alt="research"
                    />
                    <h6>Research</h6>
                </Link>
                <Link to={"/university-news-letter"}>
                    <img
                        src="../assets/images/circle-category/news letters.png"
                        alt="news letters"
                    />
                    <h6>News Letters</h6>
                </Link>
                <Link to={"/tenders"}>
                    <img src="../assets/images/circle-category/tenders.png" alt="tenders" />
                    <h6>Tenders</h6>
                </Link>
                <Link to={"/exam-schedule"}>
                    <img src="../assets/images/circle-category/exam.png" alt="pm usha" />
                    <h6>Exam Schedule</h6>
                </Link>
                <Link to={"/viksit-bharat"}>
                    <img src="https://cdn.ccsuniversity.ac.in/public/png/2026/09/viksit-bharat-2.png" alt="Viksit-Bharat" />
                    <h6>Viksit Bharat @ 2047</h6>
                </Link>
                <Link to={"/mission-shakti"}>
                    <img
                        src="../assets/images/circle-category/LOGO-MISSION SHAKTI-CCSU-1.jpg"
                        alt="Mission Shakti"
                    />
                    <h6>Mission Shakti</h6>
                </Link>
                {/* <Link to={"https://pmusha.education.gov.in/pm-usha/#/home"} target="_blank">
                    <img src="../assets/images/circle-category/pm usha.png" alt="pm usha" />
                    <h6>PM Usha</h6>
                </Link> */}
                <Link to={"/ccsu-radio-fm"} target="_blank">
                    <img src="https://cdn.ccsuniversity.ac.in/public/png/2026/09/ccsufmradio (1).png" alt="CCSU FM" />
                    <h6>CCSU@90.8 FM Radio</h6>
                </Link>
                <Link to={"/nirf"}>
                    <img src="../assets/images/circle-category/nirf.avif" alt="NIRF" />
                    <h6>NIRF</h6>
                </Link>
            </div>
        </section>

    )
}

export default CategoryGrid;